module.exports = __webpack_public_path__ + "static/img/暂无内容@2x.2bc0b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/暂无内容@2x.png
// module id = 292
// module chunks = 379 380